import type { FC } from 'react';
import { ProductType } from '../../../../../products/types';
import { useTranslation } from 'react-i18next';
import ProductTypeIcon from '../../../../SoldProducts/ProductTypeIcon';
import { PapiDataPackageSellerOverview } from '@wix/da-papi-types';

import s from './SoldProductsTableRowHeadingMobile.scss';

interface Props {
  item: NonNullable<
    PapiDataPackageSellerOverview['timePeriods']['ALL']
  >[number];
}

const SoldProductsTableRowHeadingMobile: FC<Props> = ({ item }) => {
  const { t } = useTranslation();

  const productType = item.productType as ProductType;

  return (
    <div className={s['root']}>
      <ProductTypeIcon productType={productType} size={40} />
      <div className={s['product-type']}>
        {t(`common.productCategory.${productType}`)}
      </div>
    </div>
  );
};
SoldProductsTableRowHeadingMobile.displayName =
  'SoldProductsTableRowHeadingMobile';

export default SoldProductsTableRowHeadingMobile;
